var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("navigation-layout", { ref: "navigationlayout" }, [
    _c("h1", { attrs: { slot: "title" }, slot: "title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { slot: "abstract" }, slot: "abstract" }, [
      _vm._v(_vm._s(_vm.abstract))
    ]),
    _vm._v(" "),
    _c("main", [
      _c("div", [
        _c(
          "form",
          {
            staticClass: "md-layout md-alignment-top-center",
            attrs: { novalidate: "" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.validateIntegrator($event)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-max-size md-medium-size-33 md-small-size-50 md-xsmall-size-100"
              },
              [
                _c("field", {
                  ref: "name",
                  attrs: {
                    fieldName: "name",
                    validations: { required: true },
                    fieldValue: _vm.form.name,
                    fieldLabel: "Name",
                    fieldId: "name",
                    sending: _vm.sending
                  },
                  on: {
                    setfield: function($event) {
                      return _vm.setFormField($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("multiple-fields", {
                  ref: "trustedDomains",
                  attrs: {
                    fieldName: "trustedDomains",
                    validations: { required: true },
                    fieldValue: _vm.form.trustedDomains,
                    fieldLabel: "Trusted Domains",
                    fieldId: "trustedDomains",
                    sending: _vm.sending
                  },
                  on: {
                    setfield: function($event) {
                      return _vm.setFormField($event)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.sending
                  ? _c("md-progress-bar", {
                      attrs: { "md-mode": "indeterminate" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "md-button",
                  {
                    staticClass: "md-raised md-primary",
                    attrs: { type: "submit", disabled: _vm.sending }
                  },
                  [_vm._v("Create")]
                )
              ],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c582e68", { render: render, staticRenderFns: staticRenderFns })
  }
}